module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_down-black.116d0650.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyboard_arrow_down-black.svg
// module id = 239
// module chunks = 0